import { createContext } from 'react'

import type { PlaybookStore } from './PlaybookStore'

export const PlaybookContext = createContext<PlaybookStore | undefined>(
    undefined,
)
